import { InputNumber } from 'antd';
import { useTranslation } from 'react-i18next';

import { Wrapper } from './MinutesInput.styles';

type Props = {
  value?: number;
  onChange?: (value?: number) => void;
};

export const MinutesInput: React.FC<Props> = ({ value, onChange }) => {
  const { t } = useTranslation('CommonQuizFormTranslations');

  return (
    <Wrapper>
      <div>{t('MINUTES')}</div>
      <InputNumber
        min={0}
        max={59}
        value={value}
        onChange={number => onChange?.(number ?? undefined)}
      />
    </Wrapper>
  );
};
